import { Button, PlaceholderSegment } from '@britishcouncil/react-admin';
import { Centered } from 'components';
import { ROUTING_PATHS } from 'const';
import { useAllowedActions, useNavigationContext } from 'hooks';
import { Link, generatePath } from 'react-router';
import { Icon, SemanticICONS } from 'semantic-ui-react';

export const NoPlannedSessionsPlaceholder = () => {
  const { locationName } = useNavigationContext();
  const { createLrwSession } = ROUTING_PATHS;
  const { canCreateLrwSession } = useAllowedActions();

  return (
    <Centered>
      <PlaceholderSegment
        icon={'shapes' as unknown as SemanticICONS}
        color="grey"
        title={`${locationName} has no Listening, Reading, Writing sessions planned.`}
        description={canCreateLrwSession ? 'Would you like to create a new session?' : undefined}
      >
        {canCreateLrwSession && (
          <Link
            to={generatePath(createLrwSession.absolutePath)}
            data-testid="create-lrw-session-link"
          >
            <Button primary compact>
              <Icon name="plus square" />
              Create
            </Button>
          </Link>
        )}
      </PlaceholderSegment>
    </Centered>
  );
};
